'use strict'

exports.Raw = typeof Symbol === 'undefined' ? '__RawSymbol__' : Symbol('raw')
